class MiniCart extends HTMLElement {
  constructor() {
    super();

    this.miniCartDialogId = '#mini-cart-wrapper';
    this.cartIconId = '#cart-icon-open';
    this.miniCartDialog = document.querySelector(this.miniCartDialogId);
    this.cartIcon = document.querySelector(this.cartIconId);
    this.cartLink = document.querySelector('#cart-icon-bubble');
    this.cartItems = document.querySelector('#mini-cart-items');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.template = this.dataset.template;
    this.mobile = window.matchMedia("(max-width: 768px)").matches;

    this.setHeaderCartIconAccessibility();
    this.handleItemsScroll();
  }

  setHeaderCartIconAccessibility() {
    if (this.cartLink) {
      this.cartLink.setAttribute('role', 'button');
      this.cartLink.setAttribute('aria-haspopup', 'dialog');
      this.cartIcon.addEventListener('click', (event) => {
        event.preventDefault();
        this.open();
      });
      this.cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open();
        }
      });
    }
  }

  setPosition(scrollY){
    if (!this.mobile) {
      if(scrollY > 300){
        this.closest("dialog").style.marginTop = "10.5rem";
      }
      else{
        this.closest("dialog").style.marginTop = "12.5rem";
      }
    }
  }

  open() {
    if(this.template == "index") this.setPosition(window.scrollY);
    this.miniCartDialog.querySelector('iframe')?.setAttribute('scrolling', 'no');
    this.miniCartDialog.show();
    if(this.mobile) document.querySelector("body").classList.add("overflow-hidden-tablet");
    document.body.addEventListener('click', this.onBodyClick);
  }
  
  close() {
    this.miniCartDialog.close();
    document.body.removeEventListener('click', this.onBodyClick);
    document.querySelector("body").classList.remove("overflow-hidden-tablet");
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (
      target !== this.miniCartDialog && !target.closest(this.miniCartDialogId) &&
      target !== this.cartIcon && !target.closest(this.cartIconId)
    ) {
      this.close();
    }
  }

  handleItemsScroll() {
    this.cartItems?.addEventListener('scroll', () => {
      if (this.cartItems.scrollTop != 0) {
        this.cartItems.classList.add('scrolled');
      } else {
        this.cartItems.classList.remove('scrolled');
      }

      if (Math.abs(this.cartItems.scrollHeight - this.cartItems.clientHeight - this.cartItems.scrollTop) < 1) {
        this.cartItems.classList.add('scroll-end');
      } else {
        this.cartItems.classList.remove('scroll-end');
      }
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        selector: '#mini-cart'
      },
      {
        id: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);

class MiniCartItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '#mini-cart',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      }
    ];
  }
}

customElements.define('mini-cart-items', MiniCartItems);